import { Action } from 'redux';
// Import States.
import {
	AppState,
} from '@app/redux/states';
// Import Actions.
import {
	LoadPossibleDocCategoriesAction,
} from '@app/redux/actions';
// Import api models.
import {
	PossibleDocCategory,
} from '@app/models/api';

/**
 * This handles initializing the state.
 * @param state
 * @param action
 */
let initializeState = (state: AppState): AppState => {
	let newState: AppState = { ...state };
	newState.possibleDocCategories = [...newState.possibleDocCategories];
	return newState;
}

// Load Possible Doc Categories Reducer.

let LoadPossibleDocCategoriesReducer = (state: AppState, action: Action): AppState => {
	let loadPossibleDocCategoriesAction: LoadPossibleDocCategoriesAction = action as LoadPossibleDocCategoriesAction;
	let possibleDocCategories: PossibleDocCategory[] = loadPossibleDocCategoriesAction.possibleDocCategories;

	// Create copy of the of app state.
	let newState: AppState = initializeState(state);

	newState.possibleDocCategories = possibleDocCategories;
	newState.arePossibleDocCategoriesLoaded = true;

	return newState;
}

// Export reducers.
export {
	LoadPossibleDocCategoriesReducer,
};